enum NotificationTabEnum {
  ALL = 'ALL',
  UNREAD = 'UNREAD',
}

enum NotificationTypeEnum {
  ITEM_STOCK_LOW = 'ITEM_STOCK_LOW',
}

export { NotificationTabEnum, NotificationTypeEnum };
